// tslint:disable: max-line-length
import { Component, OnInit, ViewChild, Inject, ElementRef } from '@angular/core';
import { DwSectionBaseComponent, DwComponentSectionPreference, DwComponentType, DwComponent, DwSelectLookupComponent, DwExpressionService, DwUiConfigRegistryService, DwUIMetaDataConfigToken, DwUIMetaDataConfig, DwMetaDataServiceToken, DwMetaDataService, DwMessagingService, DwOrmDataServiceToken, DwOrmDataService, DwQueryHelper, DwSecuritySSOService, DwSecurityRepositoryServiceToken, DwSecurityRepositoryService, DwSecurityUserService, DwQueryFilter, DwOperator, DwFilterType } from '@devwareapps/devware-cap';
import { DwFormControlLookupComponent } from '@devwareapps/devware-cap';
import { GoogleMapsModule } from '@angular/google-maps';
import { AppMetaDataService, LicensesEntity, AppMetaDataLookups } from 'src/app/meta-data/app-meta-data.service';
import { flatMap, combineLatest, map, last } from 'rxjs/operators';
import { Observable, of } from 'rxjs';
import { WachterUserExt } from 'src/app/shared/models/wachter-user.model';
import { validateClaimsRequest } from 'msal/lib-commonjs/AuthenticationParameters';
import { AbstractControl, FormControl } from '@angular/forms';
import { ConfigService } from 'src/environments/environment';
import { NumberSequence } from 'ag-grid-community';


@DwComponent({
  name: 'ProjectName',
  parentItemName: 'Kickoff',
  componentType: DwComponentType.formSection,
})

@Component({
  selector: 'app-project-name-control',
  templateUrl: 'project-name.component.html'
})
export class ProjectName extends DwSectionBaseComponent<DwComponentSectionPreference>
  implements OnInit {


  wAppsApiUrl: string;
  selectedString: string;
  LookupId = AppMetaDataLookups.ETHOSUSERWachterEmployeesActiveEmployees;
  bearerToken: string;

  // fileId: number;
  constructor(dwExpressionService: DwExpressionService,
    dwUiConfigRegistryService: DwUiConfigRegistryService,
    private msalHandler: DwSecuritySSOService,
    @Inject(DwUIMetaDataConfigToken) uiMetaDataConfig: DwUIMetaDataConfig,
    @Inject(DwMetaDataServiceToken) dwMetaDataService: DwMetaDataService,
    @Inject(DwOrmDataServiceToken) private dataService: DwOrmDataService,
     private securityService: DwSecurityUserService,
    @Inject(DwSecurityRepositoryServiceToken) private securityRepository: DwSecurityRepositoryService,
    private messageService: DwMessagingService) {
    super(dwExpressionService, dwUiConfigRegistryService, uiMetaDataConfig, dwMetaDataService);
  }

  ngOnInit() {

    super.ngOnInit();
    this.LookupId = AppMetaDataLookups.ETHOSUSERWachterEmployeesActiveEmployees;


        this.formGroup.get("Ethos_JobNumberId").valueChanges.subscribe(x => {
          if (x != null){
          this.getEthosJobNumber(x).subscribe(y => {
            let z : any = y[0];
            this.selectedString = z.JobName;
            })
          }
          })

        if (this.formGroup.value != null && this.formGroup.value.EmployeeEthos_UserId != null){
          this.getEthosJobNumber(this.formGroup.value.EmployeeEthos_UserId).subscribe(y => {
            let z : any = y[0];
            this.selectedString = z.JobName;
            })
          }
  }

getEthosJobNumber(jobNumberId: number) {
  if (typeof jobNumberId === 'string') {
    jobNumberId = parseInt(jobNumberId, 10);
  }
  const md = new AppMetaDataService();
    const qh = new DwQueryHelper();
    const filter: DwQueryFilter = new DwQueryFilter();
    filter.Attr = md.EthosJobNumber.JobNumberId;
    filter.Value = jobNumberId.toString();
    filter.Op = DwOperator.And;
    filter.Type = DwFilterType.Equal;
    const query = md.EthosJobNumber.CreateQuery().AddFilterAnd(filter);


    return this.dataService.executeQuery(query);
}

}
